import Plyr from 'plyr';

let videoFrame = (function () {
  let i18nTrad = require('./plyr/src/locales/fr.js');
  let playersArray = [];
  function _init() {
    const players = document.querySelectorAll('.js-show-video');
    players.forEach((player,index) => {
      player.addEventListener('click', () => showButton(player));
    });
  }

  function showButton(btn) {
    const { target } = btn.dataset;
    showVideo(target);
  }

  function showVideo(video) {
    const lang = document.querySelector('html').getAttribute('lang');
    const config = {
      settings: ['speed'],
      autoplay: true,
      /* options */
    };

    if (lang === 'fr') {
      config.i18n = i18nTrad.default
    }

    let player = new Plyr(video, config);
    player.on('ready', (e) => {
      let iframe = e.target.querySelector('.plyr__video-embed iframe');
      if (iframe) {
        iframe.removeAttribute('frameborder');
        iframe.removeAttribute('width');
        iframe.removeAttribute('height');
      }
    });

    player.on('play', () => {
      if (!playersArray.includes(player)) {
        playersArray.push(player);
      }
      if (playersArray.length > 1) {
        playersArray.forEach(pl => {
          if (pl !== player) pl.pause();
        });
      }
    });
  }

  return { init: _init };
})();

export default videoFrame;
